import React from "react";
import login_bg from "../assets/images/png/before.jpg";
import medal from "../assets/images/png/Medal.png";
import original from "../assets/images/png/Original.png";
import packageicon from "../assets/images/png/Package.png";
import packageClock from "../assets/images/png/packageClock.png";
import logo from "../assets/images/png/signInLogo.png";
import { useState } from "react";
import OtpVerification from "../components/auth/OtpVerification";
import { sendOtp } from "../services/OtpServices";
import { useDispatch } from "react-redux";
import { setUserMobileNumber } from "../redux/slice/UserNumberSlice";
import { ToastContainer, toast } from "react-toastify";

const SignInPage = () => {
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [sessionId, setSessionId] = useState(""); // NEW
  const dispatch = useDispatch();

 const sendotpfun = async () => {
  const res = await sendOtp({ mobile: mobileNumber });
  if (res?.status === "success") {
    setSessionId(res.data.sessionId); // store sessionId
    toast.success("OTP sent successfully");
    setIsOtpSent(true);
    dispatch(setUserMobileNumber(mobileNumber));
  } else {
    toast.error("Failed to send OTP");
  }
};

  const sendOtpAndOtpsent = () => {
    if (mobileNumber.length === 10) {
      sendotpfun();
    
    } else {
      toast.error("Invalid Phone Number");
    }
  };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  return (
    <div className="vh-100 overflow-hidden bg_clr_light_green d-flex flex-column justify-content-center">
      <ToastContainer />
      <div className="row p-0 m-0">
        <div className="col-md-7 overflow-hidden p-0 m-0 d-none d-md-block">
          <div className="position-relative login-page-img p-0">
            <img
              className="w-100 object-fit-cover object-position-left"
              src={login_bg}
              height="100%"
            />

            <div className="position-absolute start-50 p-0 top-50 w-100 translate-middle">
              <div className="d-flex align-items-center flex-column gap-md-3 gap-1">
                <h2 className="text-center clr_white ff_heebo fs_7xl">
                  Why Choose Farmer’s City?
                </h2>
                <h3 className="text-center clr_white ff_heebo fs_xl">
                  Biggest Online Marketplace for Farmers in the World.
                </h3>
              </div>
              <div className="row gap-3 justify-content-center mt-md-4 mt-2">
                <div className="col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box">
                  <div className="w-60 custom_icon_img">
                    <img src={medal} width="100%" height="100%" />
                  </div>
                  <div className="fs_2xsm custom_icon_text">Quality</div>
                </div>
                <div className="col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box">
                  <div className="w-60 custom_icon_img">
                    <img src={packageClock} width="100%" height="100%" />
                  </div>
                  <div className="fs_2xsm custom_icon_text">On Time</div>
                </div>
                <div className="col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box">
                  <div className="w-60 custom_icon_img">
                    <img src={original} width="100%" height="100%" />
                  </div>
                  <div className="fs_2xsm custom_icon_text">
                    Original Brands
                  </div>
                </div>
                <div className="col-sm-2 col-md-4 col-lg-2 col-4 custom_icon_box">
                  <div className="w-60 custom_icon_img">
                    <img src={packageicon} width="100%" height="100%" />
                  </div>
                  <div className="fs_2xsm custom_icon_text">Free Delievery</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-5 m-0 p-0 px-2 py-md-5 bg_clr_light_green form-input-div overflow-hiddn d-md-flex justify-content-center align-items-center">
          <div className="col-md-11 col-lg-10 col-xl-9 d-flex flex-column gap-md-4 gap-1">
            <div className="d-flex flex-column gap_2">
              <div className="d-flex justify-content-center align-items-center flex-column gap-2">
                <div className="w-105 h-90">
                  <img src={logo} width="100%" height="100%" />
                </div>
                <h2 className="ff_roboto fw-700">Farmer’s City</h2>
              </div>
              <div className="d-flex text-center flex-column align-items-center gap-md-3 gap-2">
                <h2 className="ff_heebo fw-700">
                  {!isOtpSent ? "Welcome!" : "Verify your OTP"}
                </h2>
                <p className="ff_heebo clr_dark_grey_2 fw-400 fs-xsm">
                  {!isOtpSent
                    ? "Enter your phone number to access your account"
                    : "Add here OTP sent on your added phone number"}
                </p>
              </div>
            </div>

            {!isOtpSent ? (
              <div className="w-100">
                <input
                  type="number"
                  className="mb-4 w-100 py-2 px-3 custom_input"
                  placeholder="Phone Number"
                  value={mobileNumber}
                  onChange={handleMobileNumberChange}
                />
                <button
                  style={{ height: "40px", lineHeight: "0" }}
                  className="bg_dark_green clr_white custom_green_button fs_2xsm ff_heebo"
                  onClick={sendOtpAndOtpsent}
                >
                  CONTINUE
                </button>
              </div>
            ) : (isOtpSent && sessionId && (
              <OtpVerification userNumber={mobileNumber} sessionId={sessionId} />
                )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
